export default function qrCodeUrl(value = '', size = 300): string {
    
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${value}`;
}